export default "__VITE_ASSET__BAqgis$Y__"